module.exports = __webpack_public_path__ + "static/media/talisis-white-responsive.7686b527.svg";